import { BR_BLACK, DIM, RESET } from '../util/colors';
import type { LogEntry, LogLevel, StructuredLogger } from '@mimir/primitive/structuredLogger';
import { invariant } from '../util/invariant';

export class ConsoleSLogger implements StructuredLogger {
  log(entry: LogEntry) {
    writeLogEntryToConsole(entry);
  }
  async close() {
  }
}

const logMethods: Record<LogLevel, keyof Console> = {
  'alert': 'error',
  'error': 'error',
  'warn': 'warn',
  'info': 'log',
  'debug': 'debug'
};

export function writeLogEntryToConsole(entry: LogEntry) {
  const methodName = logMethods[entry.level as LogLevel] ?? 'log';
  const obj = { ...entry };
  const fields = [];
  if (obj.message) {
    fields.push(obj.message);
    delete obj.message;
  }

  if (obj.level === 'info') {
    delete obj.level;
  }

  const details = JSON.stringify(obj);
  if (details != '{}') {
    fields.push(details);
  }

  (console[methodName] as any)(fields.join(' '));
}

export function writeDecoratedEntryToConsole(prefix: string, errorColor: string, serial: number, origEntry: LogEntry) {
  invariant(typeof prefix === 'string', 'prefix must be a string');
  const entry = { ...origEntry };
  const methodName = logMethods[entry.level as LogLevel] ?? 'log';
  const fields = [];
  if (entry.message) {
    fields.push(entry.message);
  }
  delete entry.message;

  let scope = '';
  if (entry.scope) {
    if (prefix) {
      scope = ':' + entry.scope;
    } else {
      scope = entry.scope;
    }
    delete entry.scope;
  }

  if (entry.level === 'info') {
    delete entry.level;
  }

  const details = JSON.stringify(entry);
  if (details != '{}') {
    fields.push(BR_BLACK + details);
  }

  const fullMessage = fields.join(' ');
  let modifiedPrefix: string;
  const now = new Date();
  const hh = `${now.getHours()}`.padStart(2, '0');
  const mm = `${now.getMinutes()}`.padStart(2, '0');
  const ss = `${now.getSeconds()}`.padStart(2, '0');
  const timePfx = `${DIM}${hh}:${mm}:${ss}${RESET} `;

  if (prefix.includes('[')) {
    modifiedPrefix = timePfx + prefix.replace(']', `${scope}:${serial}]`) + (entry.level === 'error' ? errorColor : '');
  } else {
    let combined = prefix + scope;
    if (combined) {
      combined = timePfx + '[' + combined + '] ';
    }
    modifiedPrefix = combined + (entry.level === 'error' ? errorColor : '');
  }

  for (const line of fullMessage.split('\n')) {
    (console[methodName] as any)(`${modifiedPrefix}${line}${RESET}`);
  }
}
